import Button from 'global_elements/Button';
import { ButtonVariant } from 'global_elements/Button/variants';
import InlineText from 'global_elements/Text/InlineText';
import { FontColors, FontSizes } from 'global_elements/Text/variants';
import { JSX } from 'react';
import './styles.scss';

export type SelectableRadioButtonProps = {
  title: string;
  value: number;
  isSelected: boolean;
  extraClasses?: string;
  fontSize?: FontSizes;
  onClick: (value: number) => void;
};

export default function SelectableRadioButton(props: SelectableRadioButtonProps): JSX.Element {
  return (
    <Button variant={ButtonVariant.INVISIBLE} onClick={() => props.onClick(props.value)} extraClasses={`selectable-radio-button ${props.extraClasses ?? ''} ${props.isSelected ? '--selected' : ''}`}>
      <InlineText text={props.title} fontColor={FontColors.PRIMARY} fontSize={props.fontSize ?? FontSizes.SMALL} extraClasses={`${props.isSelected ? 'selectable-radio-button-text' : ''}`} />
    </Button>
  );
}
